import React from 'react';
import { Shield } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <Shield className="w-16 h-16 mx-auto text-slate-700 mb-4" />
            <h1 className="text-4xl font-bold text-slate-900 mb-4">Privacy Policy</h1>
            <p className="text-slate-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm p-8 lg:p-12 space-y-8">
            <div className="prose prose-slate max-w-none">
              <p className="text-lg text-slate-600">
                Au Pair Share is committed to protecting your privacy and personal information. Please review our complete Privacy Policy in the app for detailed information.
              </p>
              
              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Information We Collect</h2>
              <p className="text-slate-700 leading-relaxed">
                We collect information necessary to provide safe, reliable childcare services including:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mt-4">
                <li>Personal identification information</li>
                <li>Contact details and addresses</li>
                <li>Background check and verification documents</li>
                <li>Booking and service history</li>
                <li>Location data during active bookings</li>
                <li>Payment information</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">How We Use Your Information</h2>
              <ul className="list-disc list-inside text-slate-700 space-y-2">
                <li>Facilitate safe childcare services</li>
                <li>Verify identities and conduct background checks</li>
                <li>Process payments and bookings</li>
                <li>Provide customer support</li>
                <li>Ensure safety through tracking and monitoring</li>
                <li>Improve our services</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Data Protection</h2>
              <p className="text-slate-700 leading-relaxed">
                We employ industry-standard security measures to protect your personal information. All data is encrypted and stored securely. Access is restricted to authorized personnel only.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Information Sharing</h2>
              <p className="text-slate-700 leading-relaxed">
                We only share information necessary for service delivery (e.g., connecting families with au pairs) or as required by law. We never sell your personal information to third parties.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Your Rights</h2>
              <p className="text-slate-700 leading-relaxed">
                You have the right to access, correct, or delete your personal information. Contact our support team through the app to exercise these rights.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">POPIA Compliance</h2>
              <p className="text-slate-700 leading-relaxed">
                Au Pair Share is fully compliant with South Africa's Protection of Personal Information Act (POPIA). See our POPIA Statement for more details.
              </p>

              <div className="bg-slate-50 rounded-lg p-6 mt-8">
                <p className="text-slate-700 font-medium">
                  For our complete Privacy Policy and data protection practices, please visit the Au Pair Share app.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
